const schoolImageDB = [
    {
        src: "/school-images/tpc.jpg",
        alt: "TPC"
    },
    {
        src: "/school-images/tpc2.jpg",
        alt: "TPC"
    },
    {
        src: "/school-images/tpc3.jpg",
        alt: "TPC"
    },
    {
        src: "/school-images/tcu.jpg",
        alt: "TCU"
    },
    {
        src: "/school-images/tcu3.jpg",
        alt: "TCU"
    },
    {
        src: "/school-images/tcu4.jpg",
        alt: "TCU"
    },
    {
        src: "/school-images/tcu5.jpg",
        alt: "TCU"
    },
    {
        src: "/school-images/tcu6.jpg",
        alt: "TCU"
    },
]

export default schoolImageDB;